import map from './parser-map';
import helpers from '../helpers';

const betGroupMap = map.betGroup;

class BetGroup {
  constructor(rawObj) {
    this.id = rawObj[betGroupMap.id];
    this.active = rawObj[betGroupMap.active];
    this.description = rawObj[betGroupMap.description];
    this.name = rawObj[betGroupMap.name];
    this.shortName = rawObj[betGroupMap.shortName] || this.name;
    this.idSport = rawObj[betGroupMap.idSport];
    this.bets = rawObj[betGroupMap.bets];
    this.position = parseInt(rawObj[betGroupMap.position], 10) || helpers.maxInt;
  }
}

export default BetGroup;
